export default __webpack_public_path__ + "static/media/matic.3044a846.png";